import { Expose, Transform, Type } from 'class-transformer';
import { Point } from 'geojson';

import { SnModel } from '@lib/common/models';
import { SnLonLatBounds } from '@lib/geo/helpers';

import { FususRegionCode } from '../constants';
import { SnUser } from '../user';
import { SnFloorPlan } from './floor-plan';

export class SnFloor extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public floorPlanPending: boolean;

  @Expose()
  public floorPlanUrl: string;

  @Expose({ name: 'floorPlanBbox' })
  @Transform(SnLonLatBounds.convert)
  public floorPlanBBox: SnLonLatBounds;

  @Expose()
  public floorPlanRotation: number;

  @Expose()
  public floorPlanGeospatial: string;

  @Expose()
  public floorPlanImage: string;

  @Expose()
  public geometry: Point;

  @Expose()
  public rooms: any[];

  @Expose()
  @Type(() => Date)
  public clearedTimestamp: Date;

  @Expose()
  public clearedBy: SnUser;

  @Expose()
  public location: string;

  @Expose()
  public region?: FususRegionCode;

  @Expose()
  public floorPlans: SnFloorPlan[];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
